import styled from 'styled-components'
import BackgroundImage from 'gatsby-background-image'
export const BlogWrapper = styled.div ``;

export const BlogBox = styled.div `
    padding-bottom: 50px;
    margin-bottom: 50px;
    border-bottom: 1px solid ${props => props.theme.colors.borderColor};
`;